module.exports = __webpack_public_path__ + "static/Figma-611bc65147bf776b293e307bfdebffdb.png";